<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
        <b-row>
          <b-col sm="12">
          <b-form-group
            label="Soal"
            label-for="soal"
          >
            <b-form-textarea
              v-model="userData.soal"
              name="soal"
              placeholder="soal"
              rows="3"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" v-for="(item, index) in userData.pilihan_jawaban" :key="item">
          <b-form-group
            :label="`Pilihan ${index+1}`"
            label-for="pilihan"
          >
            <b-form-input
              v-model="item.text_pilihan"
              name="text pilihan"
              placeholder="text pilihan"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Jawaban Benar"
            label-for="jawaban benar"
          >
            <b-form-input
              v-model="userData.jawaban_benar"
              name="jawaban benar"
              placeholder="jawaban benar"
            />
          </b-form-group>
        </b-col>
        
        <b-col sm="12">
          <b-form-group
            label="Gambar"
            label-for="gambar"
          >
          <b-media no-body  class="mb-2">
              <b-media-aside>
                <b-link>
                  <b-img
                    ref="previewEl"
                    rounded
                    :src="foto"
                    height="80"
                    :key="reloadImg"
                  />
                </b-link>
                <!--/ avatar -->
              </b-media-aside>

              <b-media-body class="mt-75 ml-75">
                <!-- upload button -->
                <b-button
                  variant="primary"
                  size="sm"
                  class="mb-75 mr-75"
                  @click="$refs.refInputEl.$el.click()"
                >
                  Unggah Gambar
                </b-button>
                <b-form-file
                  ref="refInputEl"
                  v-model="filePhoto"
                  accept=".jpg, .png, .gif"
                  :hidden="true"
                  plain
                  @change="onFileSelected"
                />
                <!--/ upload button -->

                <!-- reset -->
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="mb-75 mr-75"
                  @click="resetGambar"
                >
                  Reset
                </b-button>
                <!--/ reset -->
                <div>tipe file yang diperbolehkan JPG, GIF atau PNG, ukuran 200px x 200px dan besar file maksimal 5MB</div>
              </b-media-body>
            </b-media>
        </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Status"
            label-for="status"
          >
              <b-form-radio v-model="userData.is_active" :aria-describedby="ariaDescribedby" name="some-radios" value="1" class="mb-1">Aktif</b-form-radio>
              <b-form-radio v-model="userData.is_active" :aria-describedby="ariaDescribedby" name="some-radios2" value="">Non Aktif</b-form-radio>
            </b-form-group>
        </b-col>

      </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>

      </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton, BFormTextarea,BFormFile,BLink,BMedia,BMediaAside,BImg,BMediaBody,BFormRadio,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import moment from 'moment'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import {
  uploadFoto,
  downloadPhoto,
} from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormTextarea,
    BFormFile,BLink,BMedia,BMediaAside,BImg,BMediaBody,BFormRadio,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      foto: null,
      reloadImg: 0,
      filePhoto: null,
      userData,
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.getPhoto()
  },
  methods: {
    resetGambar() {
      this.foto = null
      this.filePhoto = null
    },
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.foto);
    },
    onFileSelected(event) {
      this.foto = event.target.files[0];
      this.filePhoto = event.target.files[0];
      this.renderImage();
    },
    async getPhoto()
    {
        const responsePhoto = await downloadPhoto(this.userData.gambar);
        if (responsePhoto.data) {
          if(responsePhoto.data.status.code === '00'){
            this.foto = responsePhoto.data.data.img_base64;
            this.reloadImg += 1;
          }
        }
    },
    async updateData() {
      if (this.filePhoto != null) {
          var metadata = { }
          uploadFoto(this.filePhoto, metadata, event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          })
            .then(response1 => {
              if (response1.data.status.code === '00') {
                this.userData.gambar = response1.data.data.filename;
                store.dispatch('soal-crud/updateData', this.userData)
                .then(response => {
                  this.makeToast('success', 'Simpan Data Berhasil Dilakukan')
                  setTimeout(() => {
                    this.$router.push({name: 'soal-crud'})
                  }, 3000);
                })
                .catch(error => {
                })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengumuman',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: error,
                },
                duration: 5000,
              })
            });
        } else {
          store.dispatch('soal-crud/updateData', this.userData)
        .then(response => {
          this.makeToast('success', 'Simpan Data Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({name: 'soal-crud'})
          }, 3000);
        })
        .catch(error => {
        })
        }
     
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: 'Pengumuman',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
}
</script>

<style>

</style>
